module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Morecambe Offshore Windfarm Limited and Morgan Offshore Wind Limited",
    url:
        process.env.ELEVENTY_ENV === "dev"
            ? "https://develop--mmt-multi-consultation.netlify.app"
            : "https://www.morecambeandmorgan.com",
    defaultLocale: "en",

    base: {
        contact_address: "Freepost MORECAMBE AND MORGAN",
        contact_number: "0800 915 2493",
        contact_email: "info@morecambeandmorgan.com",
    },

    form: {
        feedback: {
            recaptcha: "6LcywMoiAAAAAJtPGmqZ8aNbyYy2hGn6Er3wK_uS",
        },
    },

    meta: {
        defaultSocialImage: "/assets/images/social.jpg",
        author: "Morecambe and Morgan",
        description:
            "Morecambe and Morgan are two new offshore wind farms being developed in the Irish Sea. The Morecambe Project is being led by Morecambe Offshore Windfarm Ltd, while Morgan Offshore Wind Farm Ltd are leading the Morgan Project.",
        gtag: "G-RHNWRT9VSH",
        gtm: "GTM-N2LCSXK",
        cookiefirst: "45f48d2f-1176-452f-8654-d91923a746cc"
    },

    consultation: {
        feedback_active: true,
        closed_message:
            "This consultation is closed and is no longer accepting feedback.",

        // Consultation close countdown. If set to true, show countdown in site header
        has_countdown: false,

        hasMap: true,

        // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
        mapUrl: "https://feedback.morecambeandmorgan.com",

        // Bugsnag API Key
        //bugsnagApiKey: "a2dd8ef727730655f512916aa67e82e1",

        // Marker.io Key - replace this default key
        marker_io: "641b32a157712c2149af08e1",
    },
};
